import {
  ADD_YAARN_RECEIVED,
  ADD_YARN_RETURN,
  YARN_RETURN_EDIT,
  YARN_RECEIVED_EDIT,
  YARN_RETURN_DELETE,
  YARN_RECEIVED_DELETE,
  GET_YARN_HISTORY,
  GET_YARN_RETURN_HISTORY,
} from "../Action/yarnIssuence";
const initialState = {
  yarnRecieved: [],
  yarnReturn: [],
  yarnHistory: [],
  yarnReturnHistory: [],
};

function clothQualityReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_YAARN_RECEIVED: {
      return {
        ...state,
        yarnRecieved: [...state.yarnRecieved, action.payload],
        yarnHistory: [action.payload, ...state.yarnHistory],
      };
    }
    case YARN_RECEIVED_EDIT: {
      let UpdateyarnReceived = state.yarnHistory.map((item) =>
        item.yarn_received_id === action.payload.id ? action.payload : item
      );
      return {
        ...state,
        yarnHistory: UpdateyarnReceived,
      };
    }
    case YARN_RECEIVED_DELETE: {
      console.log(action.payload);
      const after_delete_yarn_recevied = state.yarnHistory.filter(
        (yarnReceived) =>
          yarnReceived.yarn_received_id !== action.payload.yarn_received_id
      );
      console.log(after_delete_yarn_recevied);
      return { ...state, yarnHistory: after_delete_yarn_recevied };
    }
    case ADD_YARN_RETURN: {
      return {
        ...state,
        yarnReturn: [...state.yarnReturn, action.payload],
        yarnHistory: [action.payload, ...state.yarnHistory],
      };
    }
    case YARN_RETURN_EDIT: {
      let UpdateYarnReturn = state.yarnHistory.map((item) =>
        item.yarn_return_id === action.payload.id ? action.payload : item
      );
      return {
        ...state,
        yarnHistory: UpdateYarnReturn,
      };
    }
    case YARN_RETURN_DELETE: {
      console.log(action.payload);
      const after_delete_yarn_return = state.yarnReturnHistory.filter(
        (yarnReturn) =>
          yarnReturn.yarn_return_id !== action.payload.yarn_return_id
      );
      console.log(after_delete_yarn_return);
      return { ...state, yarnReturnHistory: after_delete_yarn_return };
    }
    case GET_YARN_HISTORY: {
      return {
        ...state,
        yarnHistory: action.payload,
      };
    }
    case GET_YARN_RETURN_HISTORY: {
      return {
        ...state,
        yarnReturnHistory: action.payload,
      };
    }
    default:
      return state;
  }
}

export default clothQualityReducer;
